import { css } from 'design'
import React from 'react'
import { useSelector } from 'react-redux'

import { WidgetHeaderBar } from '../../../components/live_chat_widget/widget_header_bar'
import { getCurrentQuestion } from '../../../reduxes/slices/questions/selectors'
import { ProductPreview } from './product_preview'

export const Products = () => {
  const currentQuestion = useSelector(getCurrentQuestion)

  return (
    <>
      <WidgetHeaderBar />
      <div className={questionContainerStyles()}>
        <h2>{currentQuestion.text}</h2>
        {currentQuestion.data.products?.map((url) => {
          return <ProductPreview key={url} url={url} />
        })}
      </div>
    </>
  )
}

const questionContainerStyles = css({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  height: '100%',
  zIndex: 1,

  h2: {
    textAlign: 'center',
  },
})
